import { defineComponent as _defineComponent } from 'vue'
import { BInputGroup, BInputGroupPrepend, BInputGroupAppend, BFormInput } from 'bootstrap-vue';
import { computed, ref, watch } from 'vue';


export const propsDef = {
  search: {
    type: String,
    required: false,
    default: '',
  },
  placeholder: {
    type: String,
    required: false,
    default: 'Search...',
  },
  clearable: {
    type: [Boolean, String],
    required: false,
    default: true,
  },
  label: {
    type: String,
    required: false,
  },
};

export const emitsDef = {
  'update:search': (_value: string) => true,
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: propsDef,
  emits: emitsDef,
  setup(__props, { emit }) {

const props = __props;


/**
 * {
  (e: 'update:search', value: string): void;
}
 */


const searchString = ref<string>('');

const isClearable = computed(() => props.clearable !== false && searchString.value.length);

function resetSearch() {
  searchString.value = '';
}

function onQueryChange() {
  if (props.search !== searchString.value) {
    searchString.value = props.search;
  }
}

watch(() => props.search, onQueryChange, { immediate: true });

function onSearchStringUpdated(value: string) {
  emit('update:search', value);
}

watch(
  () => searchString.value,
  (newVal) => {
    onSearchStringUpdated(newVal);
  }
);

return { __sfc: true,propsDef, emitsDef, props, emit, searchString, isClearable, resetSearch, onQueryChange, onSearchStringUpdated, BInputGroup, BInputGroupPrepend, BInputGroupAppend, BFormInput }
}

})